<template>
  <div id="my-loading-box" :class="{ pcStyle: isPc, mobileStyle: isMobile }">
    <div class="my-loading-content">
      <div id="my-loading-content-box">
        <img class="loading-img" width="30" height="30" src="@/assets/images/loading.png" alt="" />
        <div id="my-loading-title"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ResizeMixin from '@/mixin/ResizeHandler';
export default {
  name: 'live-video',
  mixins: [ResizeMixin],
};
</script>

<style lang="less" scoped>
#my-loading-box {
  display: none;
  position: fixed;
  top: 0;
  z-index: 10010;
  .my-loading-content {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10010;
    justify-content: center;
    align-items: center;
    display: -webkit-flex;

    #my-loading-content-box {
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      padding: 30px 30px;
      font-size: 30px;
      border-radius: 5px;
      max-width: 70vw;
      word-break: break-all;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 50px;
      min-height: 50px;
      .loading-img {
        animation: rotate 1.5s linear infinite;
      }
      #my-loading-title {
        margin-top: 20px;
        display: none;
      }
    }
  }
}
#my-loading-box.pcStyle {
  #my-loading-content-box {
    min-width: 100px;
    min-height: 100px;
    padding: 0;
    font-size: 15px;
    #my-loading-title {
      margin-top: 10px;
    }
  }
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
</style>
